import { CanActivateFn, Router } from '@angular/router';
import { InicioService } from '../services/inicio.service';
import { catchError, map, of } from 'rxjs';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const accesoService = inject(InicioService);

  let token = '';

  if (typeof window !== 'undefined' && !!localStorage.getItem('token')) {
    token = localStorage.getItem('token') || ""
  }
  else{
    token = '';
  }

  if(token != ""){
    return accesoService.validaToken(token).pipe(
      map(dt =>{
        console.log('te estoy viendo')
        if(dt.valor){
          return true;
        }else{
          localStorage.removeItem('token');
          localStorage.removeItem('usuSesion');
          accesoService.updateLogeo(null);
          router.navigateByUrl("");
          return false;
        }
      }),catchError(er => {
        localStorage.removeItem('token');
        localStorage.removeItem('usuSesion');
        accesoService.updateLogeo(null);
        router.navigateByUrl("");
        return of(false);
      })
    )
  }else{
    //router.navigateByUrl("");
    //return false;
    //Esta es otra forma de hacerlo
    const url = router.createUrlTree([""]);
    return url;
  }

};
